import React, { useContext, useEffect, useMemo } from 'react';
import { useParams, Redirect, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined } from '@ant-design/icons';

import Product from '../Product';
import { Loader, Page, useHelmet } from '../../../common';
import { ProductContext } from '../../providers/ProductProvider';
import { Button, Row, Text } from '../../../../common';

import './styles.less';

const ProductItem = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { getProduct, productState } = useContext(ProductContext);
  const { product, isLoading, isSuccess } = productState;
  useHelmet({ title: product ? product.info.title : '' });

  useEffect(() => {
    getProduct(id);
  // eslint-disable-next-line
  }, []);

  return useMemo(() => {
    if (isLoading) return <Loader />;

    if (product) return (
      <Page className="product-container">
        <Row full mb={20} justify="flex-start">
          <Link to={'/products'}>
            <Button invisible style={{ padding: 0 }}>
              <Row align="center">
                <ArrowLeftOutlined style={{ marginRight: 10 }} />
                <Text h4 white style={{lineHeight: 1}}>{t`Back to store`}</Text>
              </Row>
            </Button>
          </Link>
        </Row>
        <Product product={product} />
      </Page>
    );

    if (!product && isSuccess) return <Redirect to="/" />;

    return null;
  }, [isLoading, product, t, isSuccess]);
};

ProductItem.propTypes = {};

export default ProductItem;